import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import { Trans } from "@lingui/react/macro";
import styles from "./LoggedIntoAppChip.module.scss";

const LoggedIntoAppChip = () => {
  return (
    <CustomProperties className={styles["logged-in"]}>
      <Chip border="solid" background="solid" shape="sharp" size="small">
        <Trans>Inloggad i patientapp</Trans>
      </Chip>
    </CustomProperties>
  );
};

export default LoggedIntoAppChip;
